import api from '../../../services/api';
import {
  CustomerOptionDto,
  FactoryOptionDto,
  SupplierOptionDto,
  UserOptionDto,
  normalizeCustomerOptions,
  normalizeFactoryOptions,
  normalizeSupplierOptions,
  normalizeUserOptions,
} from '../../../dto/reference';

export async function fetchCustomerOptions(entity = 'referenceData.customers'): Promise<CustomerOptionDto[]> {
  const response = await api.get('/customers');
  return normalizeCustomerOptions(response.data, entity);
}

export async function fetchSupplierOptions(entity = 'referenceData.suppliers'): Promise<SupplierOptionDto[]> {
  const response = await api.get('/suppliers');
  return normalizeSupplierOptions(response.data, entity);
}

export async function createSupplier(payload: Record<string, unknown>): Promise<SupplierOptionDto> {
  const response = await api.post('/suppliers', payload);
  return normalizeSupplierOptions([response.data])[0];
}

export async function fetchFactoryOptions(): Promise<FactoryOptionDto[]> {
  const response = await api.get('/factories');
  return normalizeFactoryOptions(response.data);
}

export async function createFactory(payload: Record<string, unknown>): Promise<FactoryOptionDto> {
  const response = await api.post('/factories', payload);
  return normalizeFactoryOptions([response.data])[0];
}

export async function fetchAccountManagerOptions(entity = 'referenceData.accountManagers'): Promise<UserOptionDto[]> {
  const response = await api.get('/users/options');
  return normalizeUserOptions(response.data, entity);
}

export async function fetchNotificationRecipientOptions(entity = 'referenceData.notificationRecipients'): Promise<UserOptionDto[]> {
  const response = await api.get('/notifications/available-recipients');
  return normalizeUserOptions(response.data, entity);
}
